<template>
  <div>
    <v-card outlined class="pa-3 mt-4">
      <h6 class="mb-0">{{ paymentTypesNames[paymentType] }}</h6>

      <div
        v-for="(rule, i) in rules"
        :key="rule.id"
        outlined
        class="mt-4 d-flex align-end gap-2"
      >
        <span v-if="i === 0">
          <template v-if="rules.length > 1">
            Até <b>{{ rules[i + 1]?.minAmount | currency }}</b> use
          </template>
          <template v-else> Use </template>
          o gateway
        </span>
        <span v-else style="width: 70px !important"> A partir de </span>
        <v-text-field
          v-if="!!i"
          v-model="rule.minAmount"
          type="number"
          label="Valor Mínimo"
          hide-details="auto"
          class="flex-grow-0"
          dense
          prefix="R$"
          style="width: 150px !important"
          :rules="[(v) => v > 0 || 'O valor máximo deve ser maior que 0']"
          :disabled="loadingSaveGateway"
        ></v-text-field>
        <span v-if="!!i">use o gateway</span>
        <v-select
          v-model="rule.paymentMethod"
          :items="getItems(i)"
          item-text="name"
          item-value="id"
          label="Gateway"
          hide-details
          :disabled="loadingSaveGateway"
          dense
        >
        </v-select>
        <v-btn icon @click="removeRule(i)" :disabled="loadingSaveGateway">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
      <v-alert v-if="errorSaveGateway" type="error" class="mt-3">
        {{ errorSaveGateway }}
      </v-alert>
      <div class="d-flex align-center gap-2">
        <v-btn
          class="mt-3"
          color="primary"
          @click="addRule"
          small
          :disabled="
            (rules.length != 1 &&
              rules[rules.length - 1]?.minAmount === null) ||
            loadingSaveGateway
          "
          depressed
        >
          Adicionar regra
        </v-btn>
        <v-spacer />
        <v-btn
          class="mt-3"
          color="success"
          @click="saveRules"
          small
          :disabled="!isValid"
          :loading="loadingSaveGateway"
          depressed
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

export default {
  name: "GatewayRulesSettings",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    filteredGateways: {
      type: Array,
      required: true,
    },
    paymentType: {
      type: "CREDIT_CARD" | "PIX",
      required: true,
    },
    compatible: {
      type: "pix" | "creditCard",
      required: true,
    },
    rulesList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      rules: [],
      loadingSaveGateway: false,
      errorSaveGateway: null,
      paymentTypesNames: {
        CREDIT_CARD: "Cartão de Crédito",
        PIX: "Pix",
      },
    };
  },
  methods: {
    async saveRules() {
      this.loadingSaveGateway = true;
      this.errorSaveGateway = null;
      try {
        await platformService.updateRules(this.platform.id, this.paymentType, {
          rules: this.rules,
        });
      } catch (error) {
        this.errorSaveGateway = error.message || "Erro ao salvar gateway";
      } finally {
        this.loadingSaveGateway = false;
      }
    },
    addRule() {
      this.rules.push({
        paymentType: this.paymentType,
        minAmount: null,
        maxAmount: null,
        paymentMethod: null,
      });
      // if (this.rules.length === 1) this.addRule();
    },
    getItems(i) {
      if (i === 0) return this.validGateways;
      return this.validGateways.filter(
        (g) => g.id !== this.rules[i - 1].paymentMethod
      );
    },
    removeRule(i) {
      this.rules.splice(i, 1);
      // if (this.rules.length === 1) this.removeRule(0);
    },
    loadRules() {
      this.rules = this.rulesList.filter(
        (r) => r.paymentType === this.paymentType
      );
    },
  },
  watch: {
    rulesList: {
      handler(newVal) {
        this.loadRules();
      },
    },
  },
  computed: {
    validGateways() {
      return this.filteredGateways.filter(
        (g) => g.compatible[this.compatible]
      );
    },
    isValid() {
      return this.rules.every(
        (r, i) => r.paymentMethod && (i === 0 || r.minAmount)
      );
    },
  },
  mounted() {
    this.loadRules();
  },
};
</script>
